import React, { FC } from 'react'

export const LoadingFallback: FC = () => <div className="p-4">Loading...</div>
